import React from "react";
import { Layout, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_DARK, NAV_TYPE_SIDE, SIDE_NAV_COLLAPSED_STORAGE_KEY } from 'constants/ThemeConstant';
import { toggleCollapsedNav } from 'redux/actions/Theme';
import { Scrollbars } from 'react-custom-scrollbars';
import MenuContent from './MenuContent'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

const { Sider } = Layout;

export const SideNav = ({navCollapsed, sideNavTheme, toggleCollapsedNav, localization = true, style }) => {
  const onToggle = () => {
    const next = !navCollapsed;
    toggleCollapsedNav(next);
    try {
      localStorage.setItem(SIDE_NAV_COLLAPSED_STORAGE_KEY, next ? "1" : "0");
    } catch (e) {
      // Storage blocked: the choice still applies for this session.
    }
  };
  const label = navCollapsed ? "Expand menu" : "Collapse menu";

  return (
    <Sider
      className={`side-nav ${sideNavTheme === SIDE_NAV_DARK? 'side-nav-dark' : ''}`}
      width={SIDE_NAV_WIDTH}
      collapsedWidth={SIDE_NAV_COLLAPSED_WIDTH}
      collapsed={navCollapsed}
      style={style}
    >
      <div className="side-nav-scroll">
        <Scrollbars autoHide>
          <MenuContent type={NAV_TYPE_SIDE} localization={localization} collapsed={navCollapsed} />
        </Scrollbars>
      </div>
      <div className="side-nav-footer">
        <Tooltip title={navCollapsed ? label : null} placement="right">
          <button type="button" className="side-nav-item side-nav-collapse" aria-label={label} aria-expanded={!navCollapsed} onClick={onToggle}>
            {navCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            <span className="side-nav-item-label">{label}</span>
          </button>
        </Tooltip>
      </div>
    </Sider>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme } =  theme;
  return { navCollapsed, sideNavTheme }
};

export default connect(mapStateToProps, { toggleCollapsedNav })(SideNav);
